export default __webpack_public_path__ + "static/video-preview-3-8338e253a2be8671d70ee1b91c7cc770.webp";